const initialState = {
    resultsReportsList: [],
    resultsReport: {},
    resultsReportTemplatesList: [],
    resultsReportTemplate: {},
    resultsReportAdd: {},
    resultsReportTemplateAdd: {},
    resultsReportTemplatePatch: {},
    resultsReportTemplateDelete: {},
}

const reducer = (state = initialState, action) => {
    const newState = { ...state }

    switch (action.type) {
        case "REPORT_RESPONSE_ADD":
            newState.resultsReportAdd = action.value
            break

        case "REPORT_TEMPLATE_RESPONSE_ADD":
            newState.resultsReportTemplateAdd = action.value
            break

        case "LIST_REPORTS_TEMPLATES_RESPONSE_GET":
            newState.resultsReportTemplatesList = action.value
            break

        case "REPORT_TEMPLATE_RESPONSE_GET":
            newState.resultsReportTemplate = action.value
            break

        case "REPORT_TEMPLATE_RESPONSE_UPDATE":
            newState.resultsReportTemplatePatch = action.value
            break

        case "REPORT_TEMPLATE_RESPONSE_DELETE":
            newState.resultsReportTemplateDelete = action.value
            break

        case "RESET_REPORTS_RESPONSES":
            newState.resultsReportAdd = {}
            newState.resultsReportTemplateAdd = {}
            newState.resultsReportTemplatePatch = {}
            newState.resultsReportTemplateDelete = {}
            break

        default:
            break
    }

    return newState
}

export default reducer
